import './index.css';
import React, { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { Link, Typography } from '@mui/material';
import HandleForm from './HandleForm';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import { createArea, editArea, removeArea } from '../../services/company.service';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { AreaForm } from '../../models/area.model';
import PrimaryMenuBar from '../AreaActions/AreaViewActions/PrimaryMenuBar';
import ConfirmModal from '../common/ConfirmModal';
import useUser from "../../hooks/useUser"
import { APIResponseModel } from '../../models/api-call';
import { useNotification } from '../../context/NotificationContext';


interface AreaCreateFormProps {
  areaForm: AreaForm;
  area_code?: string,
  setBlockScreen: (p: boolean) => void;
  handleChange?: (e: any) => void;
  handleSelection?: (k: any, v: any) => void;
  action: string;
}

const AreaCreateForm: React.FC<AreaCreateFormProps> = ({
  areaForm,
  area_code = '',
  setBlockScreen,
  handleChange,
  handleSelection,
  action }) => {
    const navigate = useNavigate()
    const { selectedProject } = useProject()
    const { showNotification } = useNotification();

    const [currentAction, setCurrentAction] = useState<string>(action)
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false)
    const { userAdmin } = useUser()

  const onSubmit: SubmitHandler<AreaForm> = () => {
    setBlockScreen(true);
    Promise.all([currentAction === 'create' ? createArea(selectedProject, areaForm) :
      editArea(selectedProject, area_code, areaForm)]).then(function (results: APIResponseModel[]) {
        showNotification(
          <Typography component='span'>
            <i>Ver Área: </i>
            <Link
              sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
              underline='hover'
              href={`/${selectedProject}/area/view/${results[0].data['area_id']}`}
            >
              {results[0].data['area_name']}
            </Link>
          </Typography>)
        setBlockScreen(false);
        navigate('/areas/listing')
      }).catch((error) => {
        showNotification(error.response.data.message, 'error')
        setBlockScreen(false)
      });
  };

  const onSubmitDelete = () => {
    setBlockScreen(true)
    if (!area_code) return
    Promise.all([removeArea(selectedProject, area_code)]).then(function (result: any[]) {
      showNotification(<span>Se ha removido el Área: <i>{areaForm.name}</i></span>)
      setOpenConfirmRemoveModal(false)
      setBlockScreen(false)
      navigate('/areas/listing')
    }).catch((error) => {
      setOpenConfirmRemoveModal(false)
      showNotification(error.response.data.message, 'error')
      setBlockScreen(false)
      setTimeout(() => navigate('/areas/listing'), 1500)
    });
  }

  return (
    <React.Fragment>
      {currentAction !== 'create' &&

        (<div className='area-indicators-actions-section'>
          <div className='area-inidicators-section'>
            <IndicatorChip
              label={`Fecha de creación ${areaForm.created_date}`}
              iconDecoration={<EventAvailableOutlinedIcon />}
            />
          </div>

          <PrimaryMenuBar
            action={currentAction}
            setCurrentAction={setCurrentAction}
            handleRemove={() => setOpenConfirmRemoveModal(true)}
            canEdit={userAdmin}
          />
        </div>
        )}

      <HandleForm
        action={currentAction}
        setBlockScreen={setBlockScreen}
        handleChange={handleChange}
        handleSelection={handleSelection}
        onSubmit={onSubmit}
        areaForm={areaForm}
        selectedProject={selectedProject}
      />

      <ConfirmModal
        openModal={openConfirmRemoveModal}
        handleCloseModal={() => setOpenConfirmRemoveModal(false)}
        handleConfirm={onSubmitDelete}
      >
        <p>¿ Remover área {areaForm.name} ({areaForm.company.label}) ?</p>
      </ConfirmModal>

    </React.Fragment>
  );
}

export default AreaCreateForm;